export default {
    direction: "ltr", // rtl
    common: {
        libBooks:'Library',
        changeUserPassword:'Change Password',
        mainValue:'Main Value',
        reportSurveysDetail:'Report Surveys Detail',
        userCourses:'User Courses',
        levels:'Levels',
        tuitionPayed:'Tuition Payed',
        monthlyPayments:'Monthly Payments',
        tuitionPayment:'Tuition Payment',
        financialSetting:'Financial Setting',
        reportCard:'Report Card',
        actionGrade:'Action Grade',
        evaluationactions:'Evaluation Actions',
        evaluationActions:'Evaluation Actions',
        actions:'Actions',
        fullProfileStudent:'Full Profile Student',
        copyStudentToOtherMerchant:'Copy Student To Other Merchant',
        propaganda:'Propaganda',
        changeUserToStudentRole:'change User To Student Role',
        changeUserToRole:'change User To Role',
        itemsPerPage:'Items per page',
        generalSpecifications:'General Specifications',
        administrativeInformation:'Administrative Information',
        uploadDocuments:'Upload Documents',
        gradeReport:'Grade Report',
        home:'Home',
        permissions:'Permissions',
        teacherAbsenceReport:'Teacher Absence Report',
        grades:'Grades',
        reportStudyDiscussion:'Report Study Discussion',
        reportAbsence:'Report Absence',
        reportSurveys: 'Report Surveys',
        surveyDescriptionLabel:'First, enter the scores of all the scholars, then click the save button',
        studentAbsenceList:'Student Absence List',
        updateUserProfile:'update User Profile',
        maxPoint:'MaxPoint',
        survey:'Survey',
        manageSurvey:'Manage Survey',
        discussionStudies:'Discussion And Studies',
        agents:'Agents',
        classroomAbsence:'Classroom Absence',
        selectAgentClassroom:'Select Agent Classroom',
        downloadExcel:'downloadExcel',
        attendanceList: 'Attendance List',
        classroomList:'Classroom List',
        classroom:'Classroom',
        standardCourses:'Standard Courses',
        teacher: 'Teacher',
        courseList: 'Course List',
        courses: 'Courses',
        course: 'Course',
        dashboard: "Dashboard",
        base: "Base Information",
        transaction: "Transaction",
        action: "Action",
        business: "Business",
        attribute: "Attribute",
        countingUnit: "Counting Unit",
        entityCategory: "Entity",
        merchantCategory: "Merchant Category",
        role: "Role",
        subSystem: "Subsystem",
        subsystemAction: "Subsystem Action",
        agency: "Agency",
        branch: "Branch",
        branchAttribute: "Branch Attribute",
        branchUserAttribute: "Branch User Attribute",
        branchUserRole: "Branch User Role",
        branchUserRoleAction: "Branch User Role Action",
        entity: "Entity",
        merchant: "Merchant",
        user: "User",
        transactionDetail: "Transaction Detail",
        transactionHeader: "Transaction Header",
        createTransaction: "Create Transaction",
        customer: "Customer",
        card: "Card",
        cardGroup: "Card Group",
        branchGroup: "Branch Group",
        userCategory: "User Category",
        manualCategory: "Manual Segmentation",
        pointCategory: "Point Category",
        metricCategory: "Metric Segmentation",
        selectUsers: "Select Users",
        attributeUser: "Attribute User",
        attributeBranch: "Attribute Branch",
        attributeEntity: "Attribute Entity",
        selectSubsystems: "Select Subsystems",
        selectMerchantAttribute: "Select Merchant Attribute",
        selectBranchAttribute: "Select Branch Attribute",
        selectUserAttribute: "Select User Attribute",
        memberSegmentation: "Member Segmentation",
        mandatory: 'Mandatory',
        attributeRole: 'Attribute Role',
        attributeAction: 'Attribute Action',
        select: 'Select',
        adminManagementPanel: 'Admin Management Panel',
        accessMerchantDialog: 'Access Merchant',
        manageHappyCall: 'Manage HappyCall',
        tickets: 'Tickets',
        importData: 'Import Data',
        FAQ: 'FAQ',
        panelSMSSetting: 'Panel SMS Setting',
        approvedAndSendSMS: 'Approved And Send SMS',
        approvedAndSendEmail: 'Approved And Send Email',
        accesses: 'Accesses',
        accessToMenu: 'Access To Menu',
        accessToRoles: 'Access To Roles',
        accessToActions: 'Access To Actions',
        accessToEntityCategory: "Access To Entity Category",
        merchantSetting: 'Merchant Setting',
        newBranch: 'New Branch',
        specialSectionUsers: 'Special section for users',
        newUser: 'New User',
        relatedRoles: 'Related Roles',
        memberCategory: 'Member Category',
        giftsCategory: 'Gift Category',
        serviceCategory: 'Service Category',
        transactions: 'Transactions',
        merchantsAndBranch: 'Merchants And Branch',
        cardCategory: 'Card Category',
        giftCategory: 'Gift Category',
        next: 'Next',
        back: 'Back',
        nextLevel:'next level',
        prevLevel:'prev Level',
        agentManagementPanel: 'Agent Management Panel',
        agentMerchants: 'Agent Merchants',
        agentTransaction: 'Agent Transaction',
        agentCards: 'Agent Cards',
        agentHappycalManagment: 'Agent Happycal Managment',
        agentTickets: 'Agent Tickets',
        agentImportData: 'Agent Import Data',
        agentFAQ: 'Agent FAQ',
        agentSMSPanel: 'Agent SMS Panel',
        agentSendSMS: 'Agent Send SMS',
        agentSendEmail: 'Agent Send Email',
        settingAgentForMerchant: 'Setting Agent For Merchant',
        initialSettings: 'Initial Settings',
        additionalSetting: 'Additional Setting',
        merchantAccess: 'Merchant Access',
        merchantAccessToMenus: 'Merchant Access To Menus',
        merchantAccessToRols: 'Merchant Access To Rols',
        merchantAccessToActions: 'Merchant Access To Actions',
        merchantAccessToEntityGroups: 'Merchant Access To Entity Groups',
        merchantSettingSMS: 'Merchant Setting SMS',
        merchantSMSServiceSetting: 'Merchant SMS Service Setting',
        merchantSMSAdsSetting: 'Merchant SMS Ads Setting',
        merchantSMSServiceText: 'Merchant SMS Service Text',
        merchantEmailSetting: 'Merchant Email Setting',
        merchantRegisterSerial: 'Merchant Register Serial',
        merchantReceiveAndPay: 'Merchant Receive And Pay',
        merchantHappyCallSetting: 'Merchant HappyCall Setting',
        merchantTransactionSetting: 'Merchant Transaction Setting',
        specialSectionActions: 'Special Section Actions',
        actionTransactionSetting: 'Action Transaction Setting',
        actionAccreditationSetting: 'Action Accreditation Setting',
        actionScoringSetting: 'Action Scoring Setting',
        actionCoiningSetting: 'Action Coining Setting',
        actionSMSSetting: 'Action SMS Setting',
        actionHappycallSetting: 'Action Happycall Setting',
        specialSectionEntity: 'Special Section Entity',
        entitiesCategory: 'Entities Category',
        definitionCharacteristics: 'Definition Characteristics',
        offers: 'Offers',
        campaigns: 'Campaigns',
        definitionOffer: 'Definition Offer',
        lottery: 'Lottery',
        campaignsSendSMS: 'Campaigns Send SMS',
        offerTargets: 'Offer Targets',

        managerialSection: 'Managerial Section',
        serialsManagement: 'Serials Management',
        giftsManagement: 'Gifts Management',
        fundsManagement: 'Funds Management',
        branchManagement: 'Branch Management',
        messageManagement: 'Message Management',
        importDataManagement: 'Import Data Management',
        registerImport: 'Register Import',
        transactionImport: 'Transaction Import',
        creditImport: 'Credit Import',
        marketingManagement: 'Marketing Management',
        purchaseServicesManagement: 'Purchase Services',
        editProfileManagement: 'Edit Profile',
        reports: 'Reports',
        reportTransaction: 'Report Transaction',
        reportCampaigns: 'Report Campaigns',
        reportOffers: 'Report Offers',
        reportLottery: 'Report Lottery',
        reportMessages: 'Report Messages',
        reportTargets: 'Report Targets',
        reportCustomers: 'Report Customers',
        reportMarketing: 'Report Marketing',
        reportHappyCall: 'Report HappyCall',
        reportEntities: 'Report Entities',
        reportCards: 'Report Cards',
        reportBranches: 'Report Branches',
        reportFinancial: 'Report Financial',
        reportServiceSMS: 'Report Service SMS',
        reportAdsSMS: 'Report Ads SMS',
        reportSentEmail: 'Report Sent Email',
        reportGift: 'Report Gift',
        reportUsers: 'Report Users',
        reportImportData: 'Report Import Data',
        makeReports: 'Make Reports',
        reportMaker: 'Report Maker',
        makeReportReferrals: 'Make Report Referrals',
        makeReportVisitSite: 'Make Report Visit Site',
        operatorPanel: 'Operator Panel',
        operatorBuyTransaction: 'Operator Buy Transaction',
        operatorRegisterCustomer: 'Operator Register Customer',
        operatorBuyFactor: 'Operator Buy Factor',
        operatorIncreaseCredit: 'Operator Increase Credit',
        operatorDeductionCredit: 'Operator Deduction Credit',
        operatorDuplicateCard: 'Operator Duplicate Card',
        reportReturnRegistration: 'Report Return Registration',
        referralRegistration: 'Referral Registration',
        entryExitRegistration: 'Entry Exit Registration',
        recordingLoads: 'Recording Loads',
        paye: 'Paye',
        settings: 'Settings',
        major: 'Major',
        userList: 'User List',
        Users: 'Users',
        studentList: 'Student List',
        students: 'Students',
        teacherList: 'Teacher List',
        teachers: 'Teachers',
        employeeList: 'Employee List',
        employees: 'Employees',
        classroomLeaves:'Classroom Leaves',
        books: 'Library',
        reset: 'Reset',
        resetFilter: 'Reset Filter',
    },
    form: {
        formTimeToAll:'formTimeToAll',
        formDaysOfWeekByTime:'form Days Of Week By Time',
        classAttendanceAnnouncement:'Class attendance announcement',
        showThreePredictStudentGrades: 'Show Three Predict Student Grades',
        userCourses:'User Courses',
        newLevel:'New Level',
        userFinancial:'User Financial',
        newFinancialSetting:'New Financial Setting',
        newReportCard:'New Report Card',
        evaluationActionsMaxValue:'evaluation Actions Max Value',
        newActionGrade:'New Action Grade',
        newPropaganda:'New Propaganda',
        profilePropaganda:'Profile Propaganda',
        userInformation:'User Information',
        showAbsences:'Show Absences',
        reception:'Reception',
        manyFieldNotFill:'Many Field Not Fill',
        saveInformation:'Save Information',
        settingPermission:'Setting Permission',
        newPermission:'New Permission',
        sendNotification:'Send Notification',
        title: 'Title',
        body: 'Body',
        sendNotifications:'Send Notifications',
        newSetting:'New Setting',
        systemSettings:'System Settings',
        classroomList:'Classroom List',
        disableSelectedClasses:'Disable Selected Classes',
        collectiveEntryOfScores:'Collective entry of scores',
        newGrade:'New Grade',
        CV:'CV',
        UploadCV:'UploadCV',
        newSurvey:'New Survey',
        newClassroomLeave:'New Classroom Leave',
        allCountAbsence: 'All Count Absence',
        allCountAcceptedAbsence: 'all Count Accepted Absence',
        allCountNotAcceptedAbsence: 'all Count NotAccepted Absence',
        allCountNotRequestedAbsence: 'all CountNotRequested Absence',
        allCountRequestExcuseNotManaged: 'all Count Request Excuse Not Managed',
        allCountVisitingInPersonAbsence: 'all Count Visiting In Person Absence',
        selectAgentsClassroom:'Select Agents Classroom',
        showStudents:'Show Students',
        newClassroom:'New Classroom',
        standardCourseList:'Standard Course List',
        newStandardCourses:'New Standard Courses',
        newCourse: 'New Course',
        newStudent: 'New Student',
        newTeacher: 'New Teacher',
        selectGroupMember: 'Select Group Member',
        newAction: "Add Action",
        newAttribute: "Add Attribute",
        newCountingUnit: "Add Counting Unit",
        newEntityCategory: "Add Entity Category",
        newMerchantCategory: "Add Merchant Category",
        newRole: "Add Role",
        newSubSystem: "Add Subsystem",
        newAgency: "Add Agency",
        newBranch: "Add Branch",
        newBranchAttribute: "Add Branch Attribute",
        newBranchUserAttribute: "Add Branch User Attribute",
        newBranchUserRole: "Add Branch User Role",
        newBranchUserRoleAction: "Add Branch User Role Action",
        newEntity: "Add Entity",
        newMerchant: "Add Merchant",
        newUser: "Add User",
        newCustomer: "Add customer",
        newTransactionDetail: "Add Transaction Detail",
        newTransactionHeader: "Add Transaction Header",
        newSubsystemAction: "Add Subsystem Action",
        newTransaction: "New Transaction",
        newMemberCategory: "New Member Segmentation",
        newMetricSegmentation: "New Metric Segmentation",
        edit: "Edit",
        delete: "Delete",
        close: "Close",
        save: "Save",
        add: "Add",
        signIn: "Sign in",
        signInToSystem: "Sign in to Vali Amr App",
        search: "Search",
        searchCustomers: "Search Customers",
        selectBranch: "Select Branch",
        signOut: "Sign Out",
        newManualCategory: "Add Manual Category",
        newPointCategory: "Add Point Category",
        config: "Config",
        selectAll: "Select All",
        createPointConfig: 'Create Point Config',
        frequencyIntervalsOfCustomerVisits: 'Frequency intervals of customer visits',
        intervalsBetweenVisits: 'Intervals between visits (days)',
        customerPaymentAmountRanges: 'Customer payment amount ranges',
        from: 'From',
        to: 'To',
        coefficients: 'Coefficients',
        showMerchantSubsystems: "Show Merchant Subsystems",
        showBranchAttribute: "Show Branch Attribute",
        showUserAttribute: "Show User Attribute",
        showSubbranches: "Show Subbranches",
        showAction: "Show Action",
        selectAttribute: "Select Attribute",
        relationRoles: 'Relation Roles',
        mainRole: 'Main Role',
        selectMainRole: 'Select Main Role',
        selectAction: 'Select Action',
        selectRole: 'Select Role',
        changeStatus: 'Change Status',
        warning: 'Warning',
        editProfile: 'Edit Profile',
        transactions: 'Transactions',
        sendSms: 'Send SMS',
        location: 'Location',
        allCustomers: 'All Customers',
        allTransactions: 'All Transactions',
        totalSales: 'Total Sales',
        totalCreditIssued: 'Total Credit Issued',
        showMembers: 'Show Members',
        isActive: 'Active/DeActive',
        gift: 'Gift',
        newCardCategory: 'New Card Category',
        newGiftCategory: 'New Gift Category',
        newServiceCategory: 'New Service Category',
        newMetricCategory: 'New Metric Category',
        selectMember: 'Select Member',
        selectCardGroup: 'Select Card Group',
        metricCategory: 'Metric Category',
        selectMetrics: 'Select Metrics',
        operator: 'Operator',
        metricValue: 'Metric Value',
        selectTargetMerchant: 'Select Merchant',
        selectTargetEntity: 'Eelect Entities',
        selectTargetAction: 'Select Target Action',
        newTransactionSetting: 'New Transaction Setting',
        NewActionAccreditationSetting: 'New Accreditation Setting',
        newCreatePointConfig: 'New Create Point Config',
        showItems: 'Show Items',
        newItem: 'New Item',
        manageItems: 'Manage Items',
        campaignName: 'Campaign Name',
        selectMetricGroup: 'Select Metric Group',
        offerCondition: 'Offer Condition',
        offerReceiver: 'Offer Receiver',
        offerAward: 'Offer Award',
        campaignSetting: 'Campaign Setting',
        expireDateOffer: 'Expire Date Offer',
        expireDateOfferDescription: 'The offer received by the customer (if not used) will be lost after this date',
        notifyingCustomerOfTheOffer: 'Notifying the customer of the offer',
        notifyingCustomerOfTheOfferDescription: 'Notification text and sent SMS, type the text you want to be sent to customers in the form of SMS and notification in the box below.\n' +
            'This text is automatically sent to customers after registering the offer.',
        isNotifyingCustomerOfTheOffer: 'Sending a message to the customer for information (if it is active when registering information, an SMS will be sent to the selected customers)',
        notifyingToAppCustomers: 'Notification of the offer to the customer app',
        isNotifyingToAppCustomersDescription: 'The text of the sent message, type the text that you want to send to customers in the message app format in the box below.\n' +
            'This text is automatically sent to customers after registering the offer.',
        isNotifyingToAppCustomers: 'This message should be sent to the customer app',
        selectManualCategory: 'Select Manual Category',
        register: 'Register',
        newPaye: 'New Paye',
        newMajor: 'New Major',
        newEmployee: 'New Employee',
        allCountLag:'All Count Lag',
        thisAccessIsOnlyAppliedInReportSection:'This access is only applied in the report section',
        subTitleMajorPayePermission:'If a value is not set, it will have access to all fields and courses',
        titleOfMenusInPermissions:'Which menus does this role have access to?',
        studentAndAbsenceChart:'Student And Absence Chart',
        percentAbsenceChart:'Percent Absence Chart',
        absenceChartByTeacher:'Absence Chart By Teacher',
        absenceChartByCourse:'Absence Chart By Course',
        absenceChartByMajor:'Absence Chart By Major',
        absenceChartByPaye:'Absence Chart By Paye',
        lagDistributionChart:'Lag Distribution Chart',
        countAbsence:'Absence Count',
        percentAbsence:'Absence Percentage',
        lagExpel:'Expel',
        lagWithdraw:'Withdraw',
        averageAbsencePercent:'Average Absence Percent',
        chartOverTimeSubtitle:'Trends of absence percentages over recorded dates',
        chartDetailsSubtitle:'Statistical breakdown by various dimensions',
        noDataFound:'No data found to display',
        noDataSubtitle:'No records available for this range or category',
        refreshChart:'Refresh data',
        verticalBar:'Column Chart',
        horizontalBar:'Bar Chart',
        totalLags:'Delay % of Attendance',
        totalLagSubtitle:'Out of total student attendance',
        highestAbsenceCourse:'Top Absent Course',
        highestAbsenceTeacher:'Top Absent Teacher',
        totalRecords:'Total Records',
        notAvailable:'N/A',
        dashboardWelcomeTitle:'Welcome to the Portal',
        dashboardWelcomeSubtitle:'Attendance statistics and management dashboard',
        reset: 'Reset',
        actions: 'Actions',
    },
    fieldName: {
        allRecords: 'Total Records',
        recordsCount: 'Records Count',
        course: 'Course',
        onlyImageFiles: 'Only image files are allowed',
        rankInCourse:'Rank In Course',
        survayGrade:'Survey Grade',
        classroomPointReport:'Discipline Point',
        studentAbsenceCourseCount :'Student Absence Course Count',
        totalClassSessions: 'Total Class Sessions',
        avgAllGrade:'Avg All Grade',
        classroomGrade:'Classroom Grade',
        writtenGrade:'Written Grade',
        descriptionStudentTakenLeave:'descriptionStudentTakenLeave',
        newPassword:'New Password',
        resalahTitleLevel3:'resalahTitleLevel3',
        resalahTitleLevel4:'resalahTitleLevel4',
        specializedEducationInfo:'specializedEducationInfo',
        specializedTeachingInfo:'specializedTeachingInfo',
        uploadShShImage:'upload ShSh Image',
        uploadMelliImage:'upload Melli Image',
        cellphoneInCyberspace:'Mobile number in cyberspace',
        livelihoodInformation:'LivelihoodInformation',
        manufactureYear:'manufactureYear',
        licensePlateNumber:'licensePlateNumber',
        vehicleType:'vehicleType',
        housingType:'housingType',
        incomeSufficiency:'IncomeSufficiency',
        otherIncomeSources:'OtherIncomeSources',
        monthlyInstallmentAverage:'MonthlyInstallmentAverage',
        createDateTakenLeave:'Create Date Taken Leave',
        isCreateLeave:'Is Create Leave',
        minimumRequiredScore:'Minimum Required Score',
        isCourseIncludedInDisciplineScore:'Is Course Included In Discipline Score',
        sumPointReportSetting:'Sum Report Setting',
        showAllYearData:'Show All Year Data',
        maxPointDisciplineForReport:'Max Point Discipline For Report',
        countAcceptableAbsenceWithLeave:'Count Acceptable Absence With Leave',
        countUnAcceptableMoreThanTen:'Count UnAcceptable More Than Ten',
        countAcceptableMoreThanTen:'Count Acceptable More Than Ten',
        countDelayLessThanTen:'Count Delay Less Than Ten',
        countUnacceptableDelayLessThanTen:'count Unacceptable Delay Less Than Ten',
        countUnacceptableAbsenceWithLeave:'Count Unacceptable Absence With Leave',
        countAcceptableAbsence:'Count Acceptable Absence',
        countUnacceptableAbsence:'Count Unacceptable Absence',
        deductionPointAnyDelayLessThanTen:'Deduction Point Any Delay Less Than Ten',
        deductionPointAnyDelayUnAcceptableMoreThanTen:'Deduction Point Any Delay UnAcceptable More Than Ten',
        deductionPointAnyDelayAcceptableMoreThanTen:'Deduction Point Any Delay Acceptable More Than Ten',
        deductionPointByAcceptableAbsenceWithLeave:'deduction Point By Acceptable Absence With Leave',
        deductionPointByUnacceptableAbsenceWithLeave:'Deduction Point By Unacceptable Absence With Leave',
        showAttendancesAbsent:'Show absences that have been present and absent',
        absenceOfOfficialHoliday:'Absence Of Official Holiday',
        absenceOfStudents:'Absence Of Students',
        absenceOfOther:'Absence Of Other',
        absenceOfUnknown:'Absence Of Unknown',
        attendanceStatus:'Attendance Status',
        showAttendances:'Show Attendances',
        showDetailSurvey:'Show Detail Survey',
        allAttendance:'All Attendance',
        sumScoreValue:'Sum Score Value',
        sumMainValue:'Sum Main Value',
        dependentsList:'Dependents List',
        employmentStatus:'Is Employed?',
        education:'Education',
        sicks:'Sicks',
        identificationNumber:'IdentificationNumber',
        saturday: 'Saturday',
        sunday: 'Sunday',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        agentsName:'Agent Name',
        dependents:'Dependents',
        principlePresent:'Principle Present',
        levelName:'Level Name',
        level:'Level',
        totalReceived:'Total Received',
        userAddsAmounts:'User Adds Amounts',
        pointsAmount:'Points Amount',
        newTuitionPayment:'New Tuition Payment',
        addsAmount:'Adds Amount',
        amount:'Amount',
        tuitionAmount:'TuitionAmount',
        maximumPointsAmount:'MaximumPointsAmount',
        marriageAmount:'MarriageAmount',
        amountOfChild:'AmountOfChild',
        deductions:'Deductions',
        checkPassFail:'Check Pass/Fail',
        maxAbsenceConfirmedUnit:'Max Absence Confirmed Unit',
        maxAbsenceDisConfirmedUnit:'Max Absence Dis Confirmed Unit',
        dayOfMonthReportCard:'dayOfMonthReportCard',
        gradeActions:'Grade Actions',
        reportCardType:'ReportCard Type',
        percentPoint:'Percent Point',
        maxPoint:'maxPoint',
        sumPoint:'Sum Point',
        gradesYearly:'Grades Yearly',
        gradesTerm:'Grades Term',
        gradesMidterm:'Grades Midterm',
        gradesMonthly:'Grades Monthly',
        gradesWeekly:'Grades Weekly',
        gradesDaily:'Grades Daily',
        reportCardStartDate:'reportCard Start Date',
        reportCardEndDate:'ReportCard End Date',
        evaluationActionTitle:'Action Name',
        scoreDate:'score Date',
        selectActions:'Select Actions',
        maxValue:'Max Value',
        withMerchant:'with Merchant',
        individualOrGroup:'individual Or Group',
        areaPropaganda:'area Propaganda',
        professionalPropaganda:'professional Propaganda',
        numberYearAdvertisingHistory:'Number Year Advertising History',
        feghExam:'fegh Exam',
        osulExam:'osul Exam',
        comprehensiveScores:'Comprehensive Scores',
        locationPropaganda:'Location Propaganda',
        title:'Title',
        time:'Time',
        influenceAndInfluence:'Influence And Influence',
        placeforSendingGroup:'Place for Sending Group',
        fixedAdvertisingLocation:'Fixed Advertising Location',
        wifesAbility:'Wife Ability',
        advertisingTrainingCourses:'Advertising Training Courses',
        withMerchantFileNumber:'Merchant File Number',
        nahadFileNumber:'Nahad File Number',
        defaFileNumber:'Defa File Number',
        farajaFileNumber:'Faraja File Number',
        arteshFileNumber:'Artesh File Number',
        sepahFileNumber:'Sepah File Number',
        oghafFileNumber:'Oghaf File Number',
        organizationtFileNumber:'Organizationt File Number',
        samtaFileNumber:'Samta File Number',
        samavatFileNumber:'Samavat File Number',
        virtualPropaganda:'Virtual Propaganda',
        village:'village',
        villageCity:'Village Or City',
        villageOrCity:'Village Or City',
        part:'Part',
        county:'County',
        province:'Province',
        remainingTime:'Remaining Time',
        timeNumberOfUnits:'Time Number Of Units',
        dividedCourseRequest:'Divided Course Request',
        writtenExam:'written Exam',
        cognitiveOralExam:'cognitive Oral Exam',
        scientificOralExam:'scientific Oral Exam',
        resultOfExamPeriod:'result Of Exam Period',
        isFatherAlive:'is Father Alive',
        marriageDate:'marriage Date',
        birthDate:'birth Date',
        uploadYourTranscriptFile:'upload Your Transcript File',
        uploadAcademicEvaluationFile:'upload Academic Evaluation File',
        countScorePeriod:'Count Score Period',
        sumScorePeriod:'Sum Score Period',
        avgScorePeriod:'Avg Score Period',
        countAllScore:'Count All Score',
        sumAllScore:'Sum All Score',
        avgAllScore:'Avg All Score',
        sendTo:'Send To',
        automaticClassroomCreation:'Automatic Classroom Creation',
        classroomPoint:'Classroom Point',
        getMaxPointsWithMinWorkSPD:'Get Max Points With Min Work SPD',
        applyValidationMaxSPD:'Apply Validation Max SPD',
        classroomIsNotAbsence:'Classroom Is Not Absence',
        mainDiscussion:'main Discussion',
        mainStudy:'main Study',
        mainPreStudy:'main PreStudy',
        avgDiscussion:'avg Discussion',
        avgStudy:'avg Study',
        avgPreStudy:'avg PreStudy',
        maxPointSurvey:'Max Point Survey',
        closingAfterMinClassroomAttendance:'Closing After Min Classroom Attendance',
        closingTimeClassroomAttendance:'Closing Time Classroom Attendance',
        maxAbsence:'Max Absence',
        maxAbsenceUnit: 'Max Absence Unit',
        timeOfAnyClassroom:'Time Of Any Classroom',
        maxPointDiscussion:'Max Point Discussion',
        maxPointStudy:'Max Point Study',
        maxPointPreStudy:'Max Point PreStudy',
        maxPointGradesDaily:'Max Point Grades Daily',
        maxPointGradesWeekly:'Max Point Grades Weekly',
        maxPointGradesMonthly:'Max Point Grades Monthly',
        maxPointGradesMidterm:'Max Point Grades Midterm',
        maxPointGradesTerm:'Max Point Grades Term',
        maxPointGradesYearly:'Max Point Grades Yearly',
        maxPointDiscipline:'Max Point Discipline',
        minPointGradesDaily:'Min Point Grades Daily',
        minPointGradesWeekly:'Min Point Grades Weekly',
        minPointGradesMonthly:'Min Point Grades Monthly',
        minPointGradesMidterm:'Min Point Grades Midterm',
        minPointGradesTerm:'Min Point Grades Term',
        minPointGradesYearly:'Min Point Grades Yearly',
        deductionPointByUnacceptableAbsence:'Deduction Point By Unacceptable Absence',
        deductionPointByAcceptableAbsence:'Deduction Point By Acceptable Absence',
        deductionPointAnyDelay:'Deduction Point Any Delay',
        discussionStudiesBeforeDay:'Discussion Studies Before Day',
        salTahsili:'salTahsili',
        attendanceDateTime:'Attendance DateTime',
        attendanceBy:'Attendance By',
        allClassroomCount:'All Classroom Count',
        allNotHeld:'All Not Held',
        absenceOfTheTeacher:'Absence Of The Teacher',
        sumInsertedTime:'Sum Inserted Time',
        sumClassroomTime:'Sum Classroom Time',
        scoreValue:'scoreValue',
        gradePeriod: 'gradePeriod',
        gradeType:'Grade Type',
        courseType:'Course Type',
        allClassroomLeave:'All Classroom Leave',
        confirmationLeave:'Confirmation Leave',
        visitingInPersonAbsence:'visitingIn Person Absence',
        confirmationAbsence:'confirmation Absence',
        disapprovalAbsence:'disapproval Absence',
        allAbsence:'All Absence',
        firstName:'First Name',
        onlyZipFiles:'only Zip/RAR Files',
        downloadCV:'downloadCV',
        uploadYourCV:'uploadYourCV',
        lagCount:'Lag Count',
        items:'Items',
        question:'Question',
        surveyType:'Survey Type',
        minute:'Minute',
        isTakenLeave:'Is Taken Leave',
        studentCount:'Student Count',
        absenceCount:'Absence Count',
        checkAll:'Check All',
        saltahsili:'Academic Year',
        showOnlyRequestedAbsenceNotManaged:'Show Only Requested Absence Not Managed',
        managementDescription:'Management Description',
        managementOpinion:'Management Opinion',
        requestExcuse:'Request Excuse',
        studentName:'Student Name',
        createDateAbsence:'CreateDate Absence',
        selectTeacher:'Select Teacher',
        selectCourse:'Select Course',
        reasonFailure:'Reason failure',
        discussionTime:'Discussion Time',
        studyTime:'Study Time',
        preStudyTime:'preStudy Time',
        discussion:'Discussion',
        study:'Study',
        preStudy: 'PreStudy',
        research:'Research',
        numberOfUnits:'Number Of Units',
        term:'Term',
        majorName:'Major Name',
        lagTime:'Lag Time',
        createDateClassroom:'Clasroom CreateDate',
        standardCourse:'Standard Course',
        payeName:'Paye Name',
        selectedPayeName:'selected Paye Name',
        parentsCourse:'Parents Course',
        students:'Students',
        dayOfWeek:'Days Of Week',
        description: 'Description',
        fromTime: 'From Time',
        endTime: 'End Time',
        uploadYourImage: 'Upload Your Image',
        name: "Name",
        family: "Family",
        phone: "Phone",
        mobile: "Mobile",
        email: "Email",
        address: "Address",
        managerName: "Manager Name",
        managerFamily: "Manager Family",
        action: "Action",
        shSh: 'ShSh',
        password: "Password",
        isActive: "Is Active",
        langKey: "Language Key",
        companyName: "Company Name",
        // isLeaf:"Is Leaf",
        brandName: "Brand Name",
        attributesValue: "Attributes Value",
        isRequired: "Is Required",
        minLength: "Min Length",
        maxLength: "Max Length",
        // IsOwner:"Is Owner",
        value: "Value",
        registrationOriginType: "Registration Origin",
        quantity: "Quantity",
        totalValue: "Total Value",
        originType: "Registration Origin",
        unit: "Counting Unit",
        childrenCount: "Children",
        entityName: "Entity Name",
        sumValue: "Sum",
        userCount: "User Count",
        role: "Role",
        roleName: "Role Name",
        isLoginAllowed: "Allow to Login",
        subsystemName: "Subsystem Name",
        actionName: "Action Name",
        branch: "Branch",
        attribute: "Attribute",
        branchUserRole: "Branch User Role",
        merchantCategory: "Merchant Category",
        fieldType: "Field Type",
        attributeType: "Attribute Type",
        merchant: "Merchant",
        parentMerchant: "Parent Merchant",
        frequentTimes: 'Frequency Of Visits',
        frequentDistanceTimes: 'Reference Distance Coefficient',
        frequentAmountPaid: 'The coefficient of the amount paid',
        leaderRole: 'Leader Role',
        leaderName: 'Leader Name',
        subgroupRole: 'Subgroup Role',
        categoryName: 'Category Name',
        sumInvoice: "Sum Invoice",
        parentAttribute: "Parent Attribute",
        descriptionMainRoleRelated: "At the time of transaction, if user don't have this role, role to the user :",
        fromDate: "From Date",
        toDate: "To Date",
        country: 'Country',
        city: 'City',
        userName: 'UserName',
        transactionCount: 'Transaction Count',
        transactionSum: 'Transaction Sum',
        newUsers: 'New Users',
        status: 'Status',
        createDate: 'Create Date',
        expireDate: 'Expire Date',
        lastName: 'Last Name',
        uploadLogo: 'Upload Logo',
        uploadQR: 'Upload QR',
        location: 'Location',
        jobCategory: 'Job Category',
        gender: 'Gender',
        nationalCode: 'National Code',
        fund1: 'Fund 1',
        fund2: 'Fund 2',
        fund3: 'Fund 3',
        merchantType: 'Merchant Type',
        selectAgency: 'Select Agency',
        branchCount: 'Branch Count',
        isInheritAccess: 'Is Inherit Access',
        accessMerchant: 'Access Merchant',
        subGroup1: 'Sub Group 1',
        subGroup2: 'Sub Group 2',
        subGroupCount: 'Sub Group Count',
        headGroupName: 'Head Group Name',
        headGroupRole: 'Head Group Role',
        subGroupRole: 'Sub Group Role',
        groupName: 'Group Name',
        fromPoint: 'From Point',
        toTop: 'To Top',
        credit: 'Credit',
        roleGroup: 'Role Group',
        roleSubGroup: 'Role Subgroup',
        selectMember: 'Select Member',
        memberSubGroup: 'Member Subgroup',
        selectCardGroup: 'Select Card Group',
        selectLevels: 'Select Levels',
        nextMetric: 'Next Metric',
        selectEntity: 'Select Entity',
        selectSubEntity: 'Select Sub Entity',
        selectSubject: 'Select Subject',
        formula: 'Formula',
        selectParameter: 'Select Parameter',
        selectFOC: 'Select FOC',
        selectAction: 'Select Action',
        conditionApply: 'Condition Apply',
        toman: 'Toman',
        minUsableCredit: 'Minimum Usable Credit',
        maxTransactionAllowed: 'Max Transaction Allowed',
        creditExpireDateBranch: 'Credit Expire Date Branch',
        creditExpireDay: 'Credit Expire Day',
        day: 'Day',
        percent: 'Percent',
        cash: 'Cash',
        customerCanUseCreditForOfTheirPurchases: 'Customer Can Use Credit For Of Their Purchases',
        customerCanUseACertainPercentageOfHisCreditForEachPurchase: 'Customer Can Use A Certain Percentage Of His Credit For Each Purchase',
        creditNormalPercentageAllProductGroups: 'The Percentage Of Receiving Normal Credit From The Customer For All Product Groups',
        productGroups: 'Product Groups',
        creditPercentage: 'Credit Percentage',
        productGroupName: 'Product Group Name',
        selectMerchant: 'Select Merchant',
        selectBranch: 'Select Branch',
        selectAttribute: 'Select Attribute',
        mainRole: 'Main Role',
        relatedRole: 'Related Role',
        discount: 'Discount',
        getMoreCoin: 'Get More Coin',
        getMorePoint: 'Get More Point',
        pointFormula: 'Point Formula',
        forEach: 'For Each',
        receivesPoints: 'Receives Points',
        receiveSpecialService: 'Receive Special Service',
        receiveTheProduct: 'Receive The Product',
        selectDate: 'Select Date',
        dayAfterGetCredit: 'Day After Receive Credit',
        messageAfterReceiveOffer: 'Message After Receive Offer',
        messageAfterReceiveOfferDescription: 'This text will be notified as follows after receiving the offer',
        messageAfterReceiveOfferStartText: 'Receive ----- more Tomans because',
        messageAfterReceiveOfferEndText: 'Total credit ----- Tomans',
        isReceiveMessage: 'Is Receive Message',
        sendSMSToAllCustomer: 'Send to all customers',
        sendSMSToQualifyCustomer: 'Only sent to customers who qualify for this offer',
        selectManualCategory: 'Select Manual Category',
        selectSubManualCategory: 'Select SubManual Category',
        selectGroupMember: 'Select Group Member',
        selectPointCategory: 'Select Point Category',
        isMarried: 'Is Married',
        fatherName: 'Father Name',
        childCount: 'Child Count',
        sh_hesab: 'Sh Hesab',
        bankName: 'Bank Name',
        homeAddress: 'Home Address',
        homePhone: 'Home Phone',
        userRole: 'User Role',
        employeeNumber: 'Employee Number',
        studentNumber: 'Student Number',
        teacherNumber: 'Teacher Number',
        paye: 'Paye',
        major: 'Major',
        nameOrFamilyOrCellphone: 'Name Or Family Or Cellphone',
        employeeGroup: 'Employee Group',
        courseName: 'Course Name',
        teacherName: 'Teacher Name',
        confirmStatus:'Confirm Status',
        courseDate:'Course Date',
        statusTakenLeave:'Status Taken Leave',
        statusConfirm:'Status Confirm',
        isTeacherAssistant:'teacher Assistant',
        cellphone:'cellphone',
        fullName:'Full Name',
        sumMainPoint:'Sum Main Point',
        sumPersonPoint:'Sum Person Point',
        avgPoint:'Avg Point',
        elapsedTime:'Elapsed Time',
        realClassroomTime:'Real Classroom Time',
        selectUsersOfGroup:'Select Users Of Group',
        employees:'Employees',
        teachers:'Teachers',
        postalCode: 'Postal Code',
        mahal_t:'place of birth',
        hozehId:'Hozeh Id',
        yearEnteringHozeh:'year Entering Hozeh',
        cellphone2:'cellphone 2',
        previousSchoolName:'Previous School Name',
        previousSchoolCellphone:'Previous School Cellphone',
        previousSchoolTeacherCellphone:'Previous School Teacher Cellphone',
        fatherJob:'Father Job',
        fatherCellphone:'Father Cellphone',
        selectedPayeNameInRegister:'selected Paye Name In Register',
        dependentKind:'Dependent Kind',
        allowingStudentToReportAttend:'Allowing Student To Report Attend',
        achievements:'achievements',
        achievementsList:'achievementsList',
        levelAchievement:'Level Achievement',
        year : 'year'
    },
    enums: {
        housingType:{
            personal: 'Personal',
            supportive:'Supportive',
            rental : 'Rental ',
        },
        dependentKind:{
            wife:'Wife',
            children:'Children',
        },
        checkPassFail:{
            fail:'fail',
            onPerforming:'onPerforming',
            pass:'pass'
        },
        reportCardType:{
            weekly:'weekly',
            monthly:'monthly',
            yearly:'yearly'
        },
        professionalPropaganda:{
            economy :'economy',
            education :'education',
            media :'media',
            legalIssues :'legalIssues',
            family :'family',
            children_adolescents :'children_adolescents',
            mahdavit :'mahdavit',
            commandments :'commandments',
            others :'others'
        },
        areaPropaganda:{
            mosque :'mosque',
            board : 'board',
            schools :'schools',
            kidsAndTeenager : 'kidsAndTeenager',
            student : 'student',
            cyberspace : 'cyberspace',
            publicPlaces :'publicPlaces',
            others :'others'
        },
        individualOrGroup:{
            individual: 'individual',
            group: 'group'
        },
        gradeType: {
            written:'Written',
            oral:'Oral',
            research:'Research',
            classroom:'Classroom'
        },
        gradePeriod:{
            daily:'Daily',
            weekly:'Weekly',
            monthly:'Monthly',
            midterm:'Midterm',
            term:'Term',
            yearly:'Yearly'
        },
        courseType:{
            allCourse:'All Course',
            normalCourse:'Normal Course',
            assistantCourse:'assistantCourse'
        },
        surveyType:{
            students:'students',
            teachers:'teachers',
            teachersAide : 'Teachers Aide'
        },
        managementOpinion:{
            disapproval:'Disapproval',
            confirmation:'Confirmation',
            visitingInPerson:'Visiting In Person'
        },
        reasonFailure:{
            unknown:'Unknown',
            absenceOfTheTeacher:'Absence of the teacher',
            officialHoliday:'Official holiday',
            absenceOfStudents:'Absence of students',
            other:'Other'
        },
        isActive: {
            active: "Active",
            deactivate: "Deactivate"
        },
        yesNo: {
            yes: "Yes",
            no: "No"
        },
        achievementLevel:{
            national:'national',
            provincial:'provincial',
            international:'international'
        },
        payeName: {
            1: "paye 1",
            2: "paye 2",
            3: "paye 3",
            4: "paye 4",
            5: "paye 5",
            6: "paye 6",
            7: "paye 7",
            8: "paye 8",
            9: "paye 9",
            10: "paye 10",
            kharejOmoomi: "kharej Omoomi",
            kharejTakhassosiEgtesad: "kharejTakhassosiEgtesad",
            kharejTakhassosiTarbiat: "kharejTakhassosiTarbiat",
            kharejTakhassosiSiasat: "kharejTakhassosiSiasat",
            kharejTakhassosiFarhang: "kharejTakhassosiFarhang",
            kharejTakhassosiHogogh: "kharejTakhassosiHogogh",
        },
        term: {
            firstHalfYear: "First Half Year",
            secoundHalfYear: "Secound Half Year",
            summerHalfYear:'Summer Half Year'
        },
        fieldType: {
            number: "Number",
            string: "String",
            boolean: "Boolean",
            date: "Date",
            singleChoice: "SingleChoice",
            multiChoice: "MultiChoice",
            lookup: "Lookup",
            lookupMultiSelect: "LookupMultiSelect",
            file: "File"
        },
        attributeType: {
            userAttribute: "User attribute",
            branchAttribute: "Branch attribute",
            entityAttribute: "Entity attribute",
        },
        multiSelect: {
            option1: 'option 1',
            option2: 'option 2',
            option3: 'option 3',
            option4: 'option 4',
            option5: 'option 5',
            option6: 'option 6',
            option7: 'option 7',
            option8: 'option 8',
            option9: 'option 9',
            option10: 'option 10',
        },
        give: {
            toBeGiven: 'To Be Given',
            notBeGiven: 'Not Be Given'
        },
        condition: {
            conditionApplies: 'The Condition Applies',
            conditionNotApplies: 'The Condition Not Applies'
        },
        userRoles: {
            user: 'User',
            student: 'Student',
            teacher: 'Teacher',
            employee: 'Employee'
        },
        roles: {
            users: 'Users',
            students: 'Students',
            teachers: 'Teachers',
            employees: 'Employees'
        },
        employeeGroups: {
            educationAssistant: 'Education Assistant',
            specializedEducationAssistant: 'Specialized Education Assistant',
            researchAssistant: 'Research Assistant',
            culturalAssistant:'Cultural Assistant',
            ResponsibleStudents:'Responsible Students'
        },
        dayOfWeek: {
            saturday: 'Saturday',
            sunday: 'Sunday',
            monday: 'Monday',
            tuesday: 'Tuesday',
            wednesday: 'Wednesday',
            thursday: 'Thursday',
            friday: 'Friday'
        },
        rollCall:{
            attendance: 'Attendance',
            absence:'absence'
        }
    },
    successMsg: {
        successfulSave: "Successfully Saved",
        registerSuccessfulDesc:'register Successful Desc'
    },
    infoMsg: {
        emptyTable: "No record found",
        loading: "Loading...",
        underConstruction: 'Under Construction',
        profilePropagandaHistory:'profile Propaganda History'
    },
    warnMsg: {
        deleteRecord: "Do you want to delete this record?",

    },
    errorMsg: {
        recordNotFound: "Record not found",
        mobileNotFound: "Mobile Number Not Found",
        notSelectedCustomer: "Please Select Customer",
        notSelectedEntity: "Please Select at Least One Entities",
        notSelectedBranch: "Please Select One Of The Branch",
        notAccessByFilterMajorPaye:'To access, please select a major and level',
        notAllowedForSelectedRole:'Not Allowed For Selected Role',
        fillAllFields:'Fill All Fields',
        dateIsRequired:'Date Is Required'
    },
    validateMsg: {
        required: "Required",
        email: "E-mail is required",
        invalidEmail: "E-mail is not valid",
        passwordReq: "Password is required",
        mobileOnly: "Mobile is not valid",
        numberPositive: 'Number Positive Only',
        passwordLength: 'Min Length Is 6 Character',
        max1MB: 'File size should be less than 1 MB!',
        max512KB:'File size should be less than 512 KB!',
        max2MB: 'File size should be less than 2 MB!',
        maxNum:'Max num is ',
        nationalCode:'NationalCode is not valid',
        year:'year is not valid'
    },
    db: {}
}
